import { a as __rest } from '../../_tslib.esm.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import labelTagStyles from './LabelTag.styles.esm.js';
import { cn } from '../../utils/cn.esm.js';

/**
 * LabelTag component for displaying tag-style labels with different types and optional icons
 */
const LabelTag = _a => {
  var {
      className = "",
      variant = "neutral",
      text,
      icon,
      inverse = false
    } = _a,
    props = __rest(_a, ["className", "variant", "text", "icon", "inverse"]);
  const {
    container,
    iconWrapper
  } = labelTagStyles({
    variant,
    class: className,
    inverse
  });
  // Filter out interactive props to prevent clickability
  const {
      onClick,
      onKeyDown,
      onMouseDown
    } = props,
    nonInteractiveProps = __rest(props, ["onClick", "onKeyDown", "onMouseDown"]);
  return jsxs("div", Object.assign({
    className: cn(container(), className)
  }, nonInteractiveProps, {
    children: [icon && jsx("span", {
      className: iconWrapper(),
      "aria-hidden": "true",
      children: icon
    }), text]
  }));
};
LabelTag.displayName = "LabelTag";

export { LabelTag };
